export const paymentStatusOptions = [

  {
    value: "pending",
    label: "Pendiente"
  },

  {
    value: "partial",
    label: "Pago parcial"
  },

  {
    value: "paid",
    label: "Pagado"
  },

  {
    value: "refunded",
    label: "Reembolsado"
  },

  {
    value: "cancelled",
    label: "Cancelado"
  }

];